import { observable, action } from "mobx";
import axios from "axios";
import config from "../config";
import getImageByFile from "../utils/getImageByFile";

class Project {
  @observable isLoaded = false;

  @observable creation = true;

  @observable projectId = null;

  @observable removeImages = [];

  @observable formData = {
    title: "",
    description: "",
    body: "",
    timeHours: "",
    timeDays: "",
    url: "",
    mainImage: {
      file: null,
      url: null
    },
    gallery: [],
    developers: [
      {
        role: "",
        name: ""
      }
    ]
  };

  @observable projects = [];

  @observable username = "";

  @action getProjectData(id, cb) {
    if (!id) {
      this.formData = {
        title: "",
        description: "",
        body: "",
        timeHours: "",
        timeDays: "",
        url: "",
        mainImage: {
          file: null,
          url: null
        },
        gallery: [],
        developers: [
          {
            role: "",
            name: ""
          }
        ]
      };
      this.isLoaded = true;
    } else {
      axios
        .get(`/api/projects/one/${id}`)
        .then(res => {
          const projectDB = res.data.data;
          const { title, description, body, timeHours, timeDays, url, developers } = projectDB;
          let { gallery, mainImage } = projectDB;

          if (gallery) {
            gallery = gallery.map(image => {
              return {
                url: image,
                file: null
              };
            });
          } else {
            gallery = [];
          }
          mainImage = {
            url: mainImage,
            file: null
          };
          const project = {
            title,
            description,
            body,
            timeHours,
            timeDays,
            url,
            developers,
            gallery,
            mainImage
          };

          this.creation = false;
          this.isLoaded = true;
          this.formData = project;
          this.projectId = id;
          cb(false);
        })
        .catch(error => {
          cb(error);
          this.isLoaded = true;
        });
    }
  }

  @action handleChange(name, value) {
    this.formData[name] = value;
  }

  @action uploadImages(postArray) {
    return new Promise((resolve, reject) => {
      let data = new FormData();

      postArray.map(imagesObj => {
        const { files, name } = imagesObj;

        if (files) {
          files.map(file => {
            data.append(name, file);

            return true;
          });
        }

        return false;
      });
      axios
        .post("/api/upload/images", data, {
          headers: {
            accept: "application/json",
            "Accept-Language": "en-US,en;q=0.8",
            "Content-Type": `multipart/form-data; boundary=${data._boundary}`
          }
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  @action handleChangeDev(name, value, index) {
    this.formData.developers[index][name] = value;
  }

  @action addRemoveDev(add) {
    const { developers } = this.formData;
    const lastDev = developers[developers.length - 1];

    if (add) {
      developers.push({
        role: "",
        name: ""
      });
    }

    if (!add && !!lastDev) {
      developers.pop();
    }
  }

  @action handleEditorChange(body) {
    this.formData.body = body;
  }

  // Images types:

  // a) Image isn't set
  // image = {
  //   file: null,
  //   url: null
  // };

  // b) Image set locally
  // image = {
  //   file: File,
  //   url: String
  // };

  // c) Image set from server
  // image = {
  //   file: null,
  //   url: String
  // };

  @action handleChangeImg(files, type, cb) {
    for (let fileKey in files) {
      if (files.hasOwnProperty(fileKey)) {
        const file = files[fileKey];

        // get image locally
        getImageByFile(file)
          .then(img => {
            const rel = img.width / img.height;
            const url = img.src;
            let validImage = true;
            if(config.type === "portfolio" && type === "gallery"){
              validImage = rel < 16 / 8 && rel > 16 / 10;
            }
            else if(config.type === "mobile" && type === "gallery"){
              console.log(rel);
              validImage = rel > 8 / 16 && rel < 11 / 16;
            }
            if (validImage) {
              if (type === "main") {
                this.formData.mainImage = {
                  url,
                  file
                };
              } else if (type === "gallery") {
                this.formData.gallery.push({
                  url,
                  file
                });
              }
            } else {
              cb("INCORRECT_IMAGE");
            }
          })
          .catch(error => {
            cb(error);
          });
      }
    }
  }

  @action handleRemoveImage(url, type) {
    const { removeImages, formData } = this;

    if (type === "main") {
      let { mainImage } = formData;

      // if image set from server
      if (!mainImage.file && !!mainImage.url) {
        removeImages.push(mainImage.url);
      }
      this.formData.mainImage = {
        file: null,
        url: null
      };
    } else if (type === "gallery") {
      this.formData.gallery = this.formData.gallery.filter(image => {
        if (image.url !== url) {
          return true;
        } else {
          // if image set from server
          if (!image.file && !!image.url) {
            removeImages.push(image.url);
          }

          return false;
        }
      });
    }
  }

  @action saveProject(cb) {
    const { projectId, removeImages } = this;
    let formData = Object.assign({}, this.formData);
    //set type project (portfolio || mobile)
    formData.type = config.type;

    // preparing images for uploading
    const { mainImage, gallery } = formData;
    const imagesGallery = gallery.map(image => {
      return image.file;
    });
    const imagesMain = mainImage.file ? [mainImage.file] : [];
    const uploadImageParams = [
      {
        name: "image",
        files: imagesMain
      },
      {
        name: "gallery",
        files: imagesGallery
      }
    ];

    if (projectId) {
      this.uploadImages(uploadImageParams)
        .then(response => {
          const { single, multi } = response.data.data;

          // preparing mainImage for updating
          formData.mainImage = single ? single : formData.mainImage.url;

          // preparing gallery Images for updating
          let stateGallery = [];

          formData.gallery.map(image => {
            if (!image.file) {
              stateGallery.push(image.url);

              return true;
            }

            return false;
          });
          formData.gallery = multi ? [...stateGallery, ...multi] : stateGallery;

          axios
            .put(`/api/projects/`, { id: projectId, ...formData, removeImages })
            .then(() => {
              cb(false);
              this.isLoaded = true;
            })
            .catch(error => {
              cb(error);
              this.isLoaded = true;
            });
        })
        .catch(error => {
          cb(error);
        });
    } else {
      this.uploadImages(uploadImageParams)
        .then(response => {
          const { single, multi } = response.data.data;

          formData.mainImage = single;
          formData.gallery = multi;

          axios
            .post(`/api/projects/`, formData)
            .then(() => {
              cb(false);
              this.isLoaded = true;
            })
            .catch(error => {
              cb(error);
              this.isLoaded = true;
            });
        })
        .catch(error => {
          cb(error);
        });
    }
  }
}

export default new Project();



// WEBPACK FOOTER //
// ./src/stores/project.js